/**
 * 用户信息
 *
 * @author zhouwei
 * @since 2021-05-05
 */
export default class User {
    id
    name
    mobile
    role
    token
    enabled
    enabledLabel
    isAdmin;

    constructor(props) {

        var pp = props || {}
        this.id = pp.id || ''
        this.name = pp.name || ''
        this.mobile = pp.mobile || ''
        this.role = pp.role
        this.token = pp.token || ''
        this.enabled = pp.enabled || false
        this.enabledLabel = this.enabled ? '是' : '否'
        this.isAdmin = this.role === 'admin'
        this.isAdminLabel = this.isAdmin? '是' : '否'
    }

    setToken(token) {
        this.token = token
    }

    isLogined() {
        return !!this.id && this.enabled
    }
}
